import { SearchPage } from 'Components'
import TemplateSearchPage from 'Stores/xovjmui41g-1/Templates/SearchPage.rt'
import { FacetTiles } from 'Components'
import { SearchHeader } from 'Components'
import { FacetPanel } from 'Components'
import { SearchResult } from 'Components'
import { SearchBoxDialogButton } from 'Components'
import TemplatesearchBoxdialogButtonAdaptable from 'Stores/_default-store/Templates/searchBox/dialogButtonAdaptable.rt'
import TemplatesearchBoxdialogButtonMobile from 'Stores/_default-store/Templates/searchBox/dialogButtonMobile.rt'
import { VehicleWidget } from 'Components'
import TemplatefitmentSearchhomeVehicleWidget from 'Stores/_default-store/Templates/fitmentSearch/homeVehicleWidget.rt'
import { Garage } from 'Components'
import TemplatefitmentSearchgarage from 'Stores/xovjmui41g-1/Templates/fitmentSearch/garage.rt'
import { VerifyFitment } from 'Components'
import TemplatefitmentSearchverifyFitment from 'Stores/xovjmui41g-1/Templates/fitmentSearch/verifyFitment.rt'
import { FitmentTable } from 'Components'
import TemplatefitmentSearchfitmentTable from 'Stores/_default-store/Templates/fitmentSearch/fitmentTable.rt'
import TemplatefitmentSearchfitmentTableTab from 'Stores/xovjmui41g-1/Templates/fitmentSearch/fitmentTableTab.rt'
import { FacetDialog } from 'Components'
import TemplateFacetDialog from 'Stores/_default-store/Templates/FacetDialog.rt'
import TemplatefacetTileshierarchicalContainer from 'Stores/_default-store/Templates/facetTiles/hierarchicalContainer.rt'
import TemplatefacetTilesalphabeticalContainer from 'Stores/_default-store/Templates/facetTiles/alphabeticalContainer.rt'
import { ContextDialog } from 'Components'
import TemplatefitmentSearchdialog from 'Stores/xovjmui41g-1/Templates/fitmentSearch/dialog.rt'
import { VehicleTiles } from 'Components'
import { SearchBoxDialog } from 'Components'
import TemplateSearchBoxDialog from 'Stores/_default-store/Templates/SearchBoxDialog.rt'
import TemplatefitmentSearchengineLookupDialog from 'Stores/xovjmui41g-1/Templates/fitmentSearch/engineLookupDialog.rt'
import { DialogButton } from 'Components'
import TemplatefitmentSearchengineLookupDialogButton from 'Stores/xovjmui41g-1/Templates/fitmentSearch/engineLookupDialogButton.rt'
import { RequestPanel } from 'Components'

export const compMap = {
  SearchPage,
FacetTiles,
SearchHeader,
FacetPanel,
SearchResult,
SearchBoxDialogButton,
VehicleWidget,
Garage,
VerifyFitment,
FitmentTable,
FacetDialog,
ContextDialog,
VehicleTiles,
SearchBoxDialog,
DialogButton,
RequestPanel
}
export const tplMap = {
  'SearchPage': TemplateSearchPage,
'searchBox/dialogButtonAdaptable': TemplatesearchBoxdialogButtonAdaptable,
'searchBox/dialogButtonMobile': TemplatesearchBoxdialogButtonMobile,
'fitmentSearch/homeVehicleWidget': TemplatefitmentSearchhomeVehicleWidget,
'fitmentSearch/garage': TemplatefitmentSearchgarage,
'fitmentSearch/verifyFitment': TemplatefitmentSearchverifyFitment,
'fitmentSearch/fitmentTable': TemplatefitmentSearchfitmentTable,
'fitmentSearch/fitmentTableTab': TemplatefitmentSearchfitmentTableTab,
'FacetDialog': TemplateFacetDialog,
'facetTiles/hierarchicalContainer': TemplatefacetTileshierarchicalContainer,
'facetTiles/alphabeticalContainer': TemplatefacetTilesalphabeticalContainer,
'fitmentSearch/dialog': TemplatefitmentSearchdialog,
'SearchBoxDialog': TemplateSearchBoxDialog,
'fitmentSearch/engineLookupDialog': TemplatefitmentSearchengineLookupDialog,
'fitmentSearch/engineLookupDialogButton': TemplatefitmentSearchengineLookupDialogButton
};